export default __webpack_public_path__ + "static/2-5b7e3f1d7dbbaf28d220bf384736bdd0.png";